import { render } from "./DatiAziendaliView.vue?vue&type=template&id=460a7ab6"
import script from "./DatiAziendaliView.vue?vue&type=script&lang=js"
export * from "./DatiAziendaliView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__